import { createTheme } from '@mui/material/styles';
import { healthdirectPalette } from './palette';

export const theme = createTheme({
  palette: {
    primary: healthdirectPalette.primary,
    secondary: healthdirectPalette.success,
    success: healthdirectPalette.success,
    warning: healthdirectPalette.warning,
    info: healthdirectPalette.info,
    error: healthdirectPalette.error,
    background: {
      default: '#ffffff',
      paper: '#f9f9f9',
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
    },
  },
  typography: {
    fontFamily: '"Open Sans", "Arial", sans-serif',
    h1: {
      fontWeight: 'bold',
      fontSize: '2rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.5rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.1rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#000000',
      lineHeight: 1.2,
    },
    body1: {
      fontWeight: 400,
      fontSize: '1.05rem',
      lineHeight: 1.6,
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.95rem',
      lineHeight: 1.6,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            backgroundColor: '#f5f5f5',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5',
          '&:hover': {
            backgroundColor: '#eeeeee',
          },
          '&.Mui-focused': {
            backgroundColor: '#ffffff',
          },
        },
      },
    },
  },
});
